import {
  GET_SENDERS_REQUEST,
  GET_SENDERS_SUCCESS,
  GET_SENDERS_FAILURE,
  POST_SENDER_REQUEST,
  POST_SENDER_SUCCESS,
  POST_SENDER_FAILURE,
  PUT_SENDER_REQUEST,
  PUT_SENDER_SUCCESS,
  PUT_SENDER_FAILURE,
  DELETE_SENDER_REQUEST,
  DELETE_SENDER_SUCCESS,
  DELETE_SENDER_FAILURE,
  GET_USERS_ME_REQUEST,
  GET_USERS_ME_SUCCESS,
  GET_USERS_ME_FAILURE,
  DELETE_USERS_ME_REQUEST,
  DELETE_USERS_ME_SUCCESS,
  DELETE_USERS_ME_FAILURE,
  PATCH_USERS_ME_REQUEST,
  PATCH_USERS_ME_SUCCESS,
  PATCH_USERS_ME_FAILURE,
  PUT_USERS_ME_PAYMENT_REQUEST,
  PUT_USERS_ME_PAYMENT_SUCCESS,
  PUT_USERS_ME_PAYMENT_FAILURE,
  POST_USERS_ME_PAYMENT_REQUEST,
  POST_USERS_ME_PAYMENT_SUCCESS,
  POST_USERS_ME_PAYMENT_FAILURE,
  POST_POSTCODE_REQUEST,
  POST_POSTCODE_SUCCESS,
  POST_POSTCODE_FAILURE,
  POST_USERS_ME_PLANS_REQUEST,
  POST_USERS_ME_PLANS_SUCCESS,
  POST_USERS_ME_PLANS_FAILURE,
  POST_USERS_PAYMENTS_AND_PLANS_REQUEST,
  POST_USERS_PAYMENTS_AND_PLANS_SUCCESS,
  POST_USERS_PAYMENTS_AND_PLANS_FAILURE,
  GET_ORDER_CONTACTS_REQUEST,
  GET_ORDER_CONTACTS_SUCCESS,
  GET_ORDER_CONTACTS_FAILURE,
  POST_ORDER_CONTACTS_REQUEST,
  POST_ORDER_CONTACTS_SUCCESS,
  POST_ORDER_CONTACTS_FAILURE,
  DELETE_ORDER_CONTACTS_REQUEST,
  DELETE_ORDER_CONTACTS_SUCCESS,
  DELETE_ORDER_CONTACTS_FAILURE,
  GET_USER_MAILS_REQUEST,
  GET_USER_MAILS_SUCCESS,
  GET_USER_MAILS_FAILURE,
  POST_USER_MAILS_REQUEST,
  POST_USER_MAILS_SUCCESS,
  POST_USER_MAILS_FAILURE,
  DELETE_USER_MAILS_BY_ID_REQUEST,
  DELETE_USER_MAILS_BY_ID_SUCCESS,
  DELETE_USER_MAILS_BY_ID_FAILURE,
  PUT_USER_MAILS_REQUEST,
  PUT_USER_MAILS_SUCCESS,
  PUT_USER_MAILS_FAILURE,
  PATCH_USERS_EMAIL_NOTIFICATION_FLAG_REQUEST,
  PATCH_USERS_EMAIL_NOTIFICATION_FLAG_SUCCESS,
  PATCH_USERS_EMAIL_NOTIFICATION_FLAG_FAILURE,
  POST_USERS_UPDATE_PASSWORD_REQUEST,
  POST_USERS_UPDATE_PASSWORD_SUCCESS,
  POST_USERS_UPDATE_PASSWORD_FAILURE,
  REMOVE_CRM,
  SET_SHOW_DEMO_DATA,
  LOG_OUT_SUCCESS,
  GET_CHILD_USERS_REQUEST,
  GET_CHILD_USERS_SUCCESS,
  GET_CHILD_USERS_FAILURE,
  POST_CHILD_USER_REQUEST,
  POST_CHILD_USER_SUCCESS,
  POST_CHILD_USER_FAILURE,
  GET_CHILD_USER_BY_ID_REQUEST,
  GET_CHILD_USER_BY_ID_SUCCESS,
  GET_CHILD_USER_BY_ID_FAILURE,
  PUT_CHILD_USERS_AUTHORITY_REQUEST,
  PUT_CHILD_USERS_AUTHORITY_SUCCESS,
  PUT_CHILD_USERS_AUTHORITY_FAILURE,
  PATCH_CHILD_USER_AUTHORITY_BY_ID_REQUEST,
  PATCH_CHILD_USER_AUTHORITY_BY_ID_SUCCESS,
  PATCH_CHILD_USER_AUTHORITY_BY_ID_FAILURE,
  DELETE_CHILD_USERS_REQUEST,
  DELETE_CHILD_USERS_SUCCESS,
  DELETE_CHILD_USERS_FAILURE,
  GET_PROXY_LOGIN_CHILD_USER_REQUEST,
  GET_PROXY_LOGIN_CHILD_USER_SUCCESS,
  GET_PROXY_LOGIN_CHILD_USER_FAILURE,
  RESET_LATEST_EXPIRED_PLAN,
} from "../../constants/ActionTypes";
import * as messages from "../../constants/Messages";
import * as errMessages from "../../constants/ErrorMessages";
import { formatErrorMessage } from "../../utils/utils";
import { HTTP_400_BAD_REQUEST_CODE } from "../../constants/HttpStatusCode";
const { OrderedMap } = require("immutable");

const initialState = {
  senders: OrderedMap({}),
  orderContacts: OrderedMap({}),
  user: null,
  isExpiredPlan: false,
  message: "",
  errorMessage: "",
  shortMessage: "",
  hasError: false,
  isLoading: false,
  isLoadingSenders: false,
  isLoadingOrderContacts: false,
  isInitializedUser: false,
  isSaving: false,
  isSavingPlan: false,
  isSavingChildUser: false,
  showDemoData: false,
  showAddressDemoData: false,
  isLoaded: false,
  isDeleting: false,
  isDeletingChildUser: false,
  mails: OrderedMap({}),
  isLoadingMails: false,
  isLoadingChildUser: false,
  childUsers: OrderedMap({}),
  childUser: null,
  isProxyLoginLoading: false,
  proxyLoggedIn: false,
};

export default (state = initialState, action) => {
  let list;

  //default UI flags
  state = {
    ...state,
    hasError: false,
    message: "",
    errorMessage: "",
    shortMessage: "",
    error: null,
  };

  switch (action.type) {
    case GET_SENDERS_REQUEST:
      return {
        ...state,
        isLoadingSenders: true,
      };
    case GET_USERS_ME_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_SENDER_REQUEST:
    case DELETE_USER_MAILS_BY_ID_REQUEST:
    case DELETE_ORDER_CONTACTS_REQUEST:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_CHILD_USERS_REQUEST:
      return {
        ...state,
        isDeletingChildUser: true,
      };
    case DELETE_USERS_ME_REQUEST:
    case DELETE_USERS_ME_SUCCESS:
      return state;
    case POST_POSTCODE_SUCCESS:
    case POST_SENDER_REQUEST:
    case POST_ORDER_CONTACTS_REQUEST:
    case POST_POSTCODE_REQUEST:
    case PUT_SENDER_REQUEST:
    case PUT_USER_MAILS_REQUEST:
    case PUT_USERS_ME_PAYMENT_REQUEST:
    case POST_USERS_ME_PAYMENT_REQUEST:
    case POST_USER_MAILS_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case PATCH_USERS_ME_REQUEST:
      if (
        action.payload.user.hasOwnProperty("email_notification_flag") &&
        action.payload.user.email_notification_flag !==
        state.user.email_notification_flag
      ) {
        return {
          ...state,
          isSaving: true,
          user: {
            ...state.user,
            email_notification_flag:
              action.payload.user.email_notification_flag,
          },
        };
      } else if (
        action.payload.user.hasOwnProperty("new_exe_email_notif_flag") &&
        action.payload.user.new_exe_email_notif_flag !==
        state.user.new_exe_email_notif_flag
      ) {
        return {
          ...state,
          isSaving: true,
          user: {
            ...state.user,
            new_exe_email_notif_flag:
              action.payload.user.new_exe_email_notif_flag,
          },
        };
      } else if (
        action.payload.user.hasOwnProperty("update_order_status_email_notif_flag") &&
        action.payload.user.update_order_status_email_notif_flag !==
        state.user.update_order_status_email_notif_flag
      ) {
        return {
          ...state,
          isSaving: true,
          user: {
            ...state.user,
            update_order_status_email_notif_flag:
              action.payload.user.update_order_status_email_notif_flag,
          },
        };
      } else if (
        action.payload.user.hasOwnProperty("follow_call_email_notif_flag") &&
        action.payload.user.follow_call_email_notif_flag !==
        state.user.follow_call_email_notif_flag
      ) {
        return {
          ...state,
          isSaving: true,
          user: {
            ...state.user,
            follow_call_email_notif_flag:
              action.payload.user.follow_call_email_notif_flag,
          },
        };
      } else if (
        action.payload.user.hasOwnProperty("recommend_keyman_email_notif_flag") &&
        action.payload.user.recommend_keyman_email_notif_flag !==
        state.user.recommend_keyman_email_notif_flag
      ) {
        return {
          ...state,
          isSaving: true,
          user: {
            ...state.user,
            recommend_keyman_email_notif_flag:
              action.payload.user.recommend_keyman_email_notif_flag,
          },
        };
      } else {
        return {
          ...state,
          isSaving: true,
        };
      }

    case GET_SENDERS_SUCCESS:
      list = OrderedMap({});
      action.payload.senders.forEach((item) => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        senders: list,
        isLoadingSenders: false,
      };
    case POST_ORDER_CONTACTS_SUCCESS:
      return {
        ...state,
        orderContacts: state.orderContacts.set(
          action.payload.orderContact.id,
          action.payload.orderContact
        ),
        isSaving: false,
        shortMessage: messages.SAVE_SUCCESS,
      };
    case POST_SENDER_SUCCESS:
      return {
        ...state,
        senders: state.senders.set(
          action.payload.sender.id,
          action.payload.sender
        ),
        isSaving: false,
        shortMessage: messages.SAVE_SUCCESS,
      };
    case POST_USER_MAILS_SUCCESS:
      return {
        ...state,
        mails: state.mails.set(action.payload.mail.id, action.payload.mail),
        isSaving: false,
        shortMessage: messages.SAVE_SUCCESS,
      };
    case PUT_SENDER_SUCCESS:
      return {
        ...state,
        senders: state.senders.set(
          action.payload.sender.id,
          action.payload.sender
        ),
        isSaving: false,
        message: messages.SAVE_SUCCESS,
      };
    case PUT_USER_MAILS_SUCCESS:
      return {
        ...state,
        mail: state.mail.set(action.payload.mail.id, action.payload.mail),
        isSaving: false,
        message: messages.SAVE_SUCCESS,
      };
    case DELETE_SENDER_SUCCESS:
      return {
        ...state,
        shortMessage: messages.DELETE_SUCCESS,
        senders: state.senders.delete(action.payload.senderId),
        isDeleting: false,
      };
    case DELETE_USER_MAILS_BY_ID_SUCCESS:
      return {
        ...state,
        shortMessage: messages.DELETE_SUCCESS,
        mails: state.mails.delete(action.payload.userMailId),
        isDeleting: false,
      };
    case DELETE_ORDER_CONTACTS_SUCCESS:
      return {
        ...state,
        shortMessage: messages.DELETE_SUCCESS,
        orderContacts: state.orderContacts.delete(action.payload.id),
        isDeleting: false,
      };
    case DELETE_CHILD_USERS_SUCCESS:
      return {
        ...state,
        shortMessage: messages.DELETE_SUCCESS,
        isDeletingChildUser: false,
      };
    case RESET_LATEST_EXPIRED_PLAN:
      return {
        ...state,
        user: {},
        isExpiredPlan: false,
      }
    case GET_USERS_ME_SUCCESS:
      return {
        ...state,
        user: { ...action.payload.user }, // プランの有効期限に関わらず、プランの内容を表示するためuserは設定する
        isExpiredPlan: action.payload.user.active_plan === null,
        isLoading: false,
        isInitializedUser: true,
      };
    case PATCH_USERS_ME_SUCCESS:
      return {
        ...state,
        user: { ...action.payload.user },
        message: messages.SAVE_SUCCESS,
        isSaving: false,
      };
    case PATCH_USERS_ME_FAILURE:
      return {
        ...state,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_SAVE_FAILURE
        ),
        error: action.payload.error,
        isSaving: false,
      };
    case PUT_USERS_ME_PAYMENT_SUCCESS:
    case POST_USERS_ME_PAYMENT_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          user_payment: {
            ...action.payload.user_payment,
          },
        },
        message: messages.SAVE_SUCCESS,
        isSaving: false,
      };
    case GET_ORDER_CONTACTS_REQUEST:
      return {
        ...state,
        isLoadingOrderContacts: true,
      };
    case GET_ORDER_CONTACTS_SUCCESS:
      list = OrderedMap({});
      action.payload.orderContacts.forEach((item) => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        orderContacts: list,
        isLoadingOrderContacts: false,
      };
    case GET_ORDER_CONTACTS_FAILURE:
      return {
        ...state,
        isLoadingOrderContacts: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_GET_FAILURE
        ),
      };
    case GET_SENDERS_FAILURE:
      return {
        ...state,
        isLoadingSenders: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_GET_FAILURE
        ),
      };
    case GET_USERS_ME_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        error:
          typeof action.payload.error.data.message === "object"
            ? action.payload.error.data.message
            : {},
      };
    case DELETE_ORDER_CONTACTS_FAILURE:
    case DELETE_SENDER_FAILURE:
    case DELETE_USER_MAILS_BY_ID_FAILURE:
    case DELETE_CHILD_USERS_FAILURE:
      return {
        ...state,
        isDeletingChildUser: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_REMOVE_FAILURE
        ),
      };
    case DELETE_USERS_ME_FAILURE:
    case PUT_USERS_ME_PAYMENT_FAILURE:
    case POST_USERS_ME_PAYMENT_FAILURE:
      return {
        ...state,
        hasError: true,
        isSaving: false,
        error:
          typeof action.payload.error.data.message === "object"
            ? action.payload.error.data.message
            : {},
      };
    case POST_ORDER_CONTACTS_FAILURE:
    case POST_SENDER_FAILURE:
    case PUT_SENDER_FAILURE:
    case POST_USER_MAILS_FAILURE:
    case PUT_USER_MAILS_FAILURE:
      return {
        ...state,
        isSaving: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_SAVE_FAILURE
        ),
        error:
          action.payload.error.data &&
            typeof action.payload.error.data.message === "object"
            ? action.payload.error.data.message
            : {},
      };
    case POST_POSTCODE_FAILURE:
      return {
        ...state,
        hasError: true,
        error: action.payload.error,
        isSaving: false,
      };
    case POST_USERS_PAYMENTS_AND_PLANS_REQUEST:
    case POST_USERS_ME_PLANS_REQUEST:
      return {
        ...state,
        isSavingPlan: true,
      };
    case POST_USERS_PAYMENTS_AND_PLANS_SUCCESS:
    case POST_USERS_ME_PLANS_SUCCESS:
      return {
        ...state,
        isSavingPlan: false,
        message: messages.CHANGE_SUCCESS,
      };
    case POST_USERS_PAYMENTS_AND_PLANS_FAILURE:
    case POST_USERS_ME_PLANS_FAILURE: {
      let err = action.payload.error.data && action.payload.error.data.message;
      let message = "";

      if (typeof err === "string") {
        message = err;
      } else if (err && typeof err === "object") {
        // typeof null === "object" のため、nullを除外しないとObject.valuesで例外になる
        Object.values(err).forEach((item) => {
          if (Array.isArray(item)) {
            message += item.join(" ");
          }
        });
      }
      return {
        ...state,
        isSaving: false,
        errorMessage: message ? message : errMessages.ERR_SAVE_FAILURE,
      };
    }
    case REMOVE_CRM:
      return {
        ...state,
        user: {
          ...state.user,
          user_integrations: state.user.user_integrations.filter(
            (crm) => crm.integration_id !== action.payload.id
          ),
        },
      };
    case SET_SHOW_DEMO_DATA: {
      let { user } = action.payload;

      return {
        ...state,
        showDemoData: !!user.show_letter_dashboard_demo,
        showAddressDemoData: !!user.show_addresses_demo,
        isLoaded: true,
      };
    }

    case GET_USER_MAILS_REQUEST:
      return {
        ...state,
        isLoadingMails: true,
      };
    case GET_USER_MAILS_SUCCESS:
      list = OrderedMap({});
      action.payload.mails.forEach((item) => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        mails: list,
        isLoadingMails: false,
      };
    case GET_USER_MAILS_FAILURE:
      return {
        ...state,
        isLoadingMails: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_GET_FAILURE
        ),
      };
    case PATCH_USERS_EMAIL_NOTIFICATION_FLAG_REQUEST:
      return {
        ...state,
        isSaving: true,
        user: {
          ...state.user,
          email_notification_flag: action.payload.email_notification_flag,
        },
      };
    case PATCH_USERS_EMAIL_NOTIFICATION_FLAG_SUCCESS:
      return {
        ...state,
        isSaving: false,
        user: action.payload.user,
      };
    case PATCH_USERS_EMAIL_NOTIFICATION_FLAG_FAILURE:
      return {
        ...state,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_SAVE_FAILURE
        ),
        error: action.payload.error,
        isSaving: false,
      };
    case POST_USERS_UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case POST_USERS_UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        user: { ...action.payload.user },
        shortMessage: messages.SAVE_SUCCESS,
        isSaving: false,
      };
    case POST_USERS_UPDATE_PASSWORD_FAILURE:
      if (action.payload.error.status === HTTP_400_BAD_REQUEST_CODE) {
        let err = {};
        for (let key in action.payload.error.data.message) {
          if (Array.isArray(action.payload.error.data.message[key])) {
            err[key] = action.payload.error.data.message[key].join(",");
          } else if (
            typeof action.payload.error.data.message[key] === "string"
          ) {
            err[key] = action.payload.error.data.message;
          }
        }

        return {
          ...state,
          isSaving: false,
          error: err,
        };
      } else {
        return {
          ...state,
          errorMessage: errMessages.ERR_SAVE_FAILURE,
          error: action.payload.error.data,
          isSaving: false,
        };
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    case GET_CHILD_USERS_REQUEST:
      return {
        ...state,
        isLoadingChildUser: true,
      }
    case GET_CHILD_USERS_SUCCESS:
      list = OrderedMap({});
      action.payload.childUsers.forEach((item) => {
        list = list.set(item.id, item);
      });

      return {
        ...state,
        isLoadingChildUser: false,
        childUsers: list,
      }
    case GET_CHILD_USERS_FAILURE:
      return {
        ...state,
        isLoadingChildUser: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
      }
    case GET_CHILD_USER_BY_ID_REQUEST:
      return {
        ...state,
        isLoadingChildUser: true,
      }
    case GET_CHILD_USER_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingChildUser: false,
        childUser: { ...action.payload.childUser },
      }
    case GET_CHILD_USER_BY_ID_FAILURE:
      return {
        ...state,
        isLoadingChildUser: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
      }
    case POST_CHILD_USER_REQUEST:
      return {
        ...state,
        isSavingChildUser: true,
      };
    case POST_CHILD_USER_SUCCESS:
      list = OrderedMap({});
      action.payload.childUsers.forEach((item) => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        childUsers: list,
        shortMessage: messages.SAVE_SUCCESS,
        isSavingChildUser: false,
      };
    case POST_CHILD_USER_FAILURE:
      if (action.payload.error.status === HTTP_400_BAD_REQUEST_CODE) {
        let err = {};
        if (typeof action.payload.error.data.message === "string") {
          err["message"] = action.payload.error.data.message;
        } else {
          for (let key in action.payload.error.data.message) {
            if (Array.isArray(action.payload.error.data.message[key])) {
              err[key] = action.payload.error.data.message[key].join(",");
            } else if (
              typeof action.payload.error.data.message[key] === "string"
            ) {
              err[key] = action.payload.error.data.message;
            }
          }
        }

        return {
          ...state,
          isSavingChildUser: false,
          error: err,
        };
      } else {
        return {
          ...state,
          errorMessage: errMessages.ERR_SAVE_FAILURE,
          error: action.payload.error,
          isSavingChildUser: false,
        };
      }
    case PUT_CHILD_USERS_AUTHORITY_REQUEST:
      return {
        ...state,
        isSavingChildUser: true,
      };
    case PUT_CHILD_USERS_AUTHORITY_SUCCESS:
      list = OrderedMap({});
      action.payload.childUsers.forEach((item) => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        childUsers: list,
        shortMessage: messages.SAVE_SUCCESS,
        isSavingChildUser: false,
      };
    case PUT_CHILD_USERS_AUTHORITY_FAILURE:
      return {
        ...state,
        errorMessage: errMessages.ERR_SAVE_FAILURE,
        error: action.payload.error.data,
        isSavingChildUser: false,
      };
    case PATCH_CHILD_USER_AUTHORITY_BY_ID_REQUEST:
      return {
        ...state,
        isSavingChildUser: true,
      }
    case PATCH_CHILD_USER_AUTHORITY_BY_ID_SUCCESS:
      return {
        ...state,
        isSavingChildUser: false,
        childUser: action.payload.childUser,
        shortMessage: messages.SAVE_SUCCESS,
      }
    case PATCH_CHILD_USER_AUTHORITY_BY_ID_FAILURE:
      return {
        ...state,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_SAVE_FAILURE
        ),
        error: action.payload.error,
        isSavingChildUser: false,
      }
    case GET_PROXY_LOGIN_CHILD_USER_REQUEST:
      return {
        ...state,
        user: {},
        isProxyLoginLoading: true,
        proxyLoggedIn: false,
      };
    case GET_PROXY_LOGIN_CHILD_USER_SUCCESS:
      return {
        ...state,
        isProxyLoginLoading: false,
        user: { ...action.payload.user },
        proxyLoggedIn: true,
      };
    case GET_PROXY_LOGIN_CHILD_USER_FAILURE:
      return {
        ...state,
        isProxyLoginLoading: false,
        proxyLoggedIn: false,
        user: {},
        errorMessage: action.payload.error,
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/accountSetting.js